export const LISTE = {
  title: 'Liste des nomenclatures',
  breadcrumb: {
    liste: 'Liste des nomenclatures',
  },
  actions: {
    add: 'Ajouter une nomenclature',
    archive: 'Afficher les nomenclatures archivées ({nbre})',
    masquerArchiver: 'Masquer les nomenclatures archivées ({nbre})',
    archiver: 'Archiver',
  },
  tab: {
    libelle: 'Libellé',
    reference: 'Référence',
  },
  popUpArchivage: {
    titleArchiver: 'Êtes-vous sûr de vouloir archiver cette nomenclature ?',
    titleDesarchiver: 'Êtes-vous sûr de vouloir désarchiver cette nomenclature ?',
  },
  messages: {
    success: {
      archiver: 'Nomenclature archivée avec succès.',
      desarchiver: 'Nomenclature désarchivée avec succès.',
    },
  },
};

export const ADD = {
  titleAdd: 'Ajouter une nomenclature',
  titleEdit: 'Modifier la nomenclature {libelle}',
  liste: 'Liste nomenclatures',
  information: {
    libelle: 'Libellé',
    reference: 'Référence',
    schema: 'Schéma',
    proprieteOrdre: 'Ordre de propriété',
  },
  ajouterChamps: 'Ajouter des champs',
  ajoutChamp: {
    libelle: 'Champs',
    addChamp: 'Ajouter champ',
    label: 'Label',
    type: 'Type',
    ordre: 'Ordre d\'affichage',
    valeurDefaut: 'Valeur par défaut',
    valeurs: 'Valeurs',
  },
  types: {
    string: 'Texte',
    number: 'Nombre',
    booleen: 'Oui/Non',
    array: 'Liste déroulante',
  },
  success: {
    add: 'La nomenclature a été ajoutée avec succès.',
    edit: 'La nomenclature a été modifiée avec succès.',
  },
  reference: {
    technique: 'Technique',
  },
  error: {
    libelle: 'Libellé',
    reference: 'Référence',
    schema: 'Schéma',
    schemaIsNotValid: 'Le schéma de la nomenclature doit être sur un format json correct.',
    champs: 'Champs est obligatoire',
    champsExist: 'Ce champs existe déjà',
  },
  delete: {
    title: 'Etes-vous sûr de vouloir supprimer cette nomenclature ?',
    suppression: 'Nomenclature supprimée avec succès',
  },
  messWarning: {
    changeType: 'Êtes vous sûr de vouloir changer le type de champs?',
    deleteField: 'Êtes vous sûr de vouloir supprimer ce champ?',
    message: 'Vous risquez de perdre les valeurs enregistrées.',
  },
};

export const NOMENCLATURE_TECHNIQUE = {
  title: 'Nomenclature technique',
  field: {
    nomenclatureType: 'Nomenclature type',
    nomenclature: 'Nomenclature',
  },
  warning: {
    nomenclatureTypeArcive: 'La nomenclature type est actuellement archivée.',
    dataLoss: 'Vous allez perdre toutes les informations du champ nomenclature.',
  },
};
